import { Card } from '@/globalComponents/card';
import { Tab } from '@/globalComponents/tab';
import React, { useContext, useState } from 'react';
import styles from './style.module.scss';
import { TabItemText } from '@/globalComponents/tabItemText';
import activeStyles from '@/globalComponents/tabItemText/style.module.scss';
import noRequest from '../../../../public/images/noRequest.svg';
import Image from 'next/image';
import pendingRequest from '/public/images/pendingRequest.svg';
import { formatedServiceDate, formatedServiceSlot } from '@/utils/serviceRequest';
import { WebEngageContext } from '@/context/webengageContext';
import { AppScreens, WebEngageEventNames } from '@/types/wegengage';
import { ProductContext } from '@/context/productContext';
import { useRouter } from 'next/router';
import { serviceReqData, serviceReqHistoryInterface } from '@/context/serviceRequestContext';
import ImageWithFallback from '@/globalComponents/image';
import AlertIcon from '/public/images/alertModal/alertIcon.svg';
import { FullPageLoader } from './FullPageLoader';
import WebEngageUtils from '@/utils/webengageUtils';
import { useFeatureToggle } from '@/hooks/useFeatureToggle';
import { featureFlags } from '@/configs/featureFlags';

export interface DeviceInfo {
  classNames?: string;
  data: {
    waranty?: string;
    lastService?: string;
    serialNo?: number;
  };
}

export const PendingRequests = (props: { serviceReqHistory: serviceReqHistoryInterface }) => {
  const { serviceReqHistory } = props;
  const { state: productState } = useContext(ProductContext);
  const { selectedProduct } = productState;
  const { state: webengageState } = useContext(WebEngageContext);
  const router = useRouter();
  const [isFeatureEnabled] = useFeatureToggle();

  const valueClassNames = `block text-base font-medium md:text-xl ${styles.valueText}`;
  const keyValueClassNames = `py-4 text-sm font-normal flex flex-col md:gap-s6 md:flex-row md:py-6 md:text-lg ${styles.keyText}`;

  const [activeTab, setActiveTab] = useState(
    router.query?.showList === 'Closed' ? 'closedRequests' : 'openRequests',
  );
  let activeRequests =
    activeTab === 'openRequests'
      ? serviceReqHistory?.openRequests
      : serviceReqHistory?.closedRequests;
  const labelText = activeTab === 'openRequests' ? 'Open' : 'Closed';
  const [isLoading, setIsLoading] = useState(false);

  const webengageTrack = (serviceNumber: number, serviceType: string) => {
    setIsLoading(true);

    const _we = window.webengage;
    if (_we) {
      _we.track(WebEngageEventNames.SR_VIEW_MORE_CLICK, {
        ...webengageState.webengageDefault,
        navigated_from: AppScreens.SERVICE_BOOKING_SCREEN,
        customer_type: selectedProduct?.expiryStatus?.status,
        mandatory_service_open: WebEngageUtils.returnBoolString(serviceType === 'MS'),
        service_request_open: 'Yes',
        tab: 'Open',
        service_request_number: serviceNumber.toString(),
        service_type: serviceType,
      });
    }
    router
      .push({
        pathname: '/statusTracking',
        query: {
          reqId: serviceNumber.toString(),
          assetid: router.query?.assetid || selectedProduct.id,
          assets: true,
        },
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const renderComponents = (req: serviceReqData) => {
    const { slotData, serviceNumber, serviceType } = req;
    const enableDetailsLink = isFeatureEnabled(featureFlags.FEATURE_VIEW_CLOSED_REQ_DETAILS)
      ? true
      : labelText === 'Open';
    return (
      <ul className="flex flex-col md:flex-row md:justify-between">
        <li
          className={`!flex-row justify-between md:w-2/5 ${keyValueClassNames} ${styles.listBorder}`}
        >
          <p>
            Service Request no.
            <span data-testid={'Service Request no.'} className={valueClassNames}>
              {serviceNumber}
            </span>
          </p>

          <div className="md:hidden flex flex-col items-center justify-center">
            <Image src={pendingRequest} alt="pending request icon" />
            <p data-testid={labelText} className="md:text-base md:font-normal md:pb-9">
              {labelText}
            </p>
          </div>
        </li>
        <li className={`${keyValueClassNames} md:justify-between md:w-2/5`}>
          {slotData?.slot.startTime && slotData?.slot.endTime && (
            <p>
              Preferred Date & Time{' '}
              <span data-testid={'Scheduled Date & Time'} className={valueClassNames}>
                {formatedServiceDate(slotData?.slot.startTime as Date)},{' '}
                {formatedServiceSlot(
                  slotData?.slot.startTime as Date,
                  slotData?.slot.endTime as Date,
                )}
              </span>
            </p>
          )}
          {enableDetailsLink && serviceNumber && (
            <span
              onClick={() => {
                webengageTrack(serviceNumber, serviceType);
              }}
              className={`text-[0.875rem] md:text-base font-bold self-end mt-6 md:md:hidden ${styles.link}`}
              data-testid="View more details"
            >
              View more details
            </span>
          )}
        </li>
        <li
          className={`hidden md:flex md:items-end ${keyValueClassNames} md:justify-between !flex-col  md:w-1/4`}
        >
          <div className="self-end flex flex-col items-center">
            <Image src={pendingRequest} alt="pending request icon" />
            <p data-testid={labelText} className="md:text-base md:font-normal">
              {labelText}
            </p>
          </div>
          {enableDetailsLink && serviceNumber && (
            <span
              onClick={() => {
                webengageTrack(serviceNumber, serviceType);
              }}
              className={`text-[0.875rem] md:text-base font-bold self-end ${styles.link}`}
              data-testid={`View more details ${serviceNumber}`}
            >
              View more details
            </span>
          )}
        </li>
      </ul>
    );
  };

  return (
    <div className="md:mt-12">
      <Tab
        tabItems={[
          {
            id: 'openRequests',
            component: <TabItemText text={'Open'}></TabItemText>,
          },
          {
            id: 'closedRequests',
            component: <TabItemText text={'Closed'}></TabItemText>,
          },
        ]}
        activeClassNames={`${activeStyles.activeItem}`}
        classNames={`${styles.tab} inline`}
        setActiveTab={setActiveTab}
        activeTab={activeTab}
      />
      {!serviceReqHistory ? (
        <Card
          classNames={`px-4 mt-6 md:mt-8 md:px-6 md:h-max ${styles.card} p-8`}
          data-testid="service-details-error-container"
        >
          <div className="flex flex-col items-center gap-5">
            <ImageWithFallback data-testid="alert-icon" src={AlertIcon} alt={'Alert Icon'} />
            <p className="font-normal text-lg leading-6 text-[#4F4F4F]" data-testid="error-label">
              Something Went Wrong
            </p>
          </div>
        </Card>
      ) : activeRequests.length === 0 ? (
        <Card classNames={`px-4 mt-6 md:mt-8 md:px-6 md:h-max ${styles.card}`}>
          <div className="flex flex-col justify-center content-center items-center gap-s3 py-8">
            <Image src={noRequest} alt="" />
            <p
              className={`text-xl	font-medium ${styles.noRequest}`}
            >{`No ${labelText.toLowerCase()} requests`}</p>
          </div>
        </Card>
      ) : (
        activeRequests.map((req, i) => {
          return (
            <Card
              key={`index-${i}`}
              classNames={`px-4 mt-6 md:mt-8 md:px-6 md:h-max ${styles.card}`}
            >
              {renderComponents(req)}
            </Card>
          );
        })
      )}
      <FullPageLoader isLoading={isLoading} />
    </div>
  );
};
